import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import NoticesPreview from '../NoticesPreview.jpg';
import { Typography } from '../../../components/material-ui/Typography';
import { Toolbar } from '../../../components/material-ui/Toolbar';
import { Button } from '../../../components/material-ui/Button';
import { AppBar } from '../../../components/material-ui/AppBar';
import { useHideModal } from '../../../actions/modal';
import { useStyles } from './useStyles';

export const NoticeModalPreview = () => {
    const hideModal = useHideModal();
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <div className={classes.wrapper}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <Typography className={classes.title}>{translate('modal.notamPreview')}</Typography>
                    <Button onClick={hideModal} variant="contained" type="reset" className={classes.closeBtn}>
                        {translate('ok')}
                    </Button>
                </Toolbar>
            </AppBar>
            <div className={classnames(classes.wrapper, 'notice')}>
                <div modalClassName="notice">
                    <div className={classes.paper}>
                        <Typography className={classes.message}>{translate('modal.notamAccessDenied')}</Typography>
                        <img width="100%" height="auto" src={NoticesPreview} />
                    </div>
                </div>
            </div>
        </div>
    );
};
